import "core-js/modules/es6.object.define-property";

var _FlowId$BILLS_SETUP$F;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FlowId } from "../constants";
import { billsSetupFlow } from "./bills-setup";
import { yourCreditCardFlow } from "./your-credit-card";
export default (_FlowId$BILLS_SETUP$F = {}, _defineProperty(_FlowId$BILLS_SETUP$F, FlowId.BILLS_SETUP, billsSetupFlow), _defineProperty(_FlowId$BILLS_SETUP$F, FlowId.YOUR_CREDIT_CARD, yourCreditCardFlow), _FlowId$BILLS_SETUP$F);
export * from "./bills-setup"; // export { flowsSaga } from './sagas/index-saga';